import { brand, channelGroups, testimonials } from "@/mocks/homeData";

const principles = [
  {
    icon: "ri-file-list-3-line",
    title: "只做整理与索引",
    desc: "我们梳理公开渠道中已被广泛讨论的信息，标注传播脉络与时间线，不加入主观定性。",
  },
  {
    icon: "ri-shield-check-line",
    title: "标注确认程度",
    desc: "对无法核实的说法明确标注为「待确认」，避免把猜测当作结论继续扩散。",
  },
  {
    icon: "ri-compass-3-line",
    title: "入口优先于情绪",
    desc: "比起制造情绪，我们更愿意把栏目结构做清楚，让每个人都能自己找到想看的内容。",
  },
];

export default function BrandSection() {
  return (
    <section id="about" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-6">
            <span className="inline-flex items-center gap-2 font-label text-xs text-secondary-600 tracking-widest">
              <i className="ri-information-line" />
              ABOUT
            </span>
            <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-foreground-950">
              关于 {brand.name}
            </h2>
            <p className="mt-5 font-body text-sm md:text-base text-foreground-600 leading-relaxed">
              {brand.intro}
            </p>
            <p className="mt-4 font-body text-sm md:text-base text-foreground-600 leading-relaxed">
              我们的定位是一张「热点地图」：不追求做大而全的资讯池，而是把常见的查找路径整理成固定的入口，
              让第一次到访的用户也能在几十秒内熟悉整个站点。
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4">
              <div className="rounded-lg border border-background-200 bg-background-100 p-4">
                <div className="font-label text-xs text-foreground-500">内容板块</div>
                <div className="mt-1 font-heading font-black text-2xl text-primary-600">
                  {channelGroups.length}
                  <span className="text-base ml-1">个</span>
                </div>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-100 p-4">
                <div className="font-label text-xs text-foreground-500">联系邮箱</div>
                <a
                  href={`mailto:${brand.email}`}
                  className="mt-1 block font-label text-sm text-foreground-900 hover:text-primary-600 cursor-pointer break-all"
                >
                  {brand.email}
                </a>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="grid grid-cols-1 gap-4">
              {principles.map((item, index) => (
                <div
                  key={item.title}
                  className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-100 p-5"
                >
                  <span
                    className={`w-11 h-11 shrink-0 flex items-center justify-center rounded-md ${
                      index === 1
                        ? "bg-accent-100 text-accent-700"
                        : "bg-primary-100 text-primary-600"
                    }`}
                  >
                    <i className={`${item.icon} text-xl`} />
                  </span>
                  <div>
                    <h3 className="font-heading font-bold text-base text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 font-body text-sm text-foreground-600 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14">
          <h3 className="font-heading font-black text-xl md:text-2xl text-foreground-950">
            用户口碑
          </h3>
          <p className="mt-3 font-body text-sm text-foreground-600">
            来自真实用户的反馈，帮助我们不断调整频道的组织方式。
          </p>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {testimonials.map((item) => (
              <figure
                key={item.name}
                className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 flex flex-col"
              >
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className="ri-double-quotes-l" />
                </span>
                <blockquote className="mt-4 font-body text-sm text-foreground-700 leading-relaxed flex-1">
                  {item.text}
                </blockquote>
                <figcaption className="mt-5 pt-4 border-t border-background-200">
                  <div className="font-heading font-bold text-sm text-foreground-950">
                    {item.name}
                  </div>
                  <div className="font-label text-xs text-foreground-500">{item.role}</div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}